import React, { useState } from 'react';
import { Game } from '../../types/ScheduleTypes';
import { 
  SelectChangeEvent, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Box, 
  Typography, 
  Paper 
} from '@mui/material';

interface Props {
  games: Game[];
  onGameSelected: (game: Game) => void;
  label?: string;
  showPaper?: boolean;
}

export const GameSelector: React.FC<Props> = ({ 
  games, 
  onGameSelected, 
  label = "Select Game", 
  showPaper = false 
}) => {
  const [selectedGameId, setSelectedGameId] = useState<string>('');

  const handleGameChange = (event: SelectChangeEvent) => {
    const gameId = Number(event.target.value);
    const selectedGame = games.find(g => g.id === gameId);
    if (selectedGame) {
      setSelectedGameId(event.target.value);
      onGameSelected(selectedGame);
    }
  };

  const selectorContent = (
    <Box sx={{ mb: 3 }}>
      <FormControl fullWidth>
        <InputLabel id="game-select-label">{label}</InputLabel>
        <Select
          labelId="game-select-label"
          id="game-select"
          value={selectedGameId}
          label={label}
          onChange={handleGameChange}
        >
          {games.map(game => (
            <MenuItem key={game.id} value={game.id.toString()}>
              {game.date} - {game.home_club.name} vs {game.away_club.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );

  if (showPaper) {
    return (
      <Paper elevation={2} sx={{ p: 3, mb: 3, bgcolor: 'background.paper' }}>
        <Typography variant="h5" component="h2" gutterBottom>
          {label}
        </Typography>
        {games.length > 0 ? (
          selectorContent
        ) : (
          <Typography variant="body1" sx={{ py: 3, textAlign: 'center' }}>
            No games available.
          </Typography>
        )}
      </Paper>
    );
  }

  return games.length > 0 ? selectorContent : (
    <Typography variant="body1" sx={{ py: 3, textAlign: 'center' }}>
      No games available.
    </Typography>
  );
};